import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50 shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className={`ri-movie-2-line ${scrolled || !isHome ? 'text-background-50' : 'text-background-50'}`}></i>
            </div>
            <span className={`text-xl font-bold font-heading whitespace-nowrap ${
              scrolled || !isHome ? 'text-foreground-950' : 'text-background-50'
            }`}>
              成全影院
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium whitespace-nowrap transition-colors hover:text-primary-500 ${
                location.pathname === '/'
                  ? scrolled || !isHome ? 'text-primary-500' : 'text-primary-400'
                  : scrolled || !isHome ? 'text-foreground-700' : 'text-background-50'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/dongzuo"
              className={`text-sm font-medium whitespace-nowrap transition-colors hover:text-primary-500 ${
                location.pathname.startsWith('/category')
                  ? scrolled || !isHome ? 'text-primary-500' : 'text-primary-400'
                  : scrolled || !isHome ? 'text-foreground-700' : 'text-background-50'
              }`}
            >
              分类浏览
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap transition-colors hover:text-primary-500 ${
                location.pathname === '/about'
                  ? scrolled || !isHome ? 'text-primary-500' : 'text-primary-400'
                  : scrolled || !isHome ? 'text-foreground-700' : 'text-background-50'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="菜单"
          >
            <i className={`ri-menu-line text-xl ${scrolled || !isHome ? 'text-foreground-950' : 'text-background-50'}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-3">
            <Link to="/" className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 whitespace-nowrap">首页</Link>
            <Link to="/category/dongzuo" className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 whitespace-nowrap">分类浏览</Link>
            <Link to="/about" className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 whitespace-nowrap">关于我们</Link>
          </div>
        </div>
      )}
    </nav>
  );
}